import { Text, View } from '@react-pdf/renderer';
import { CoursePDFStyles } from '../course-details-pdf-css';
export function generateFeesAndPricingRow(
  feesList,
  feesTotal,
  feesNotes,
  locale,
  styles: CoursePDFStyles,
) {
  const feesAndPricingRow = feesList?.map((fee, index) => {
    return (
      <View key={`dateV-${index}`} style={[styles.tableRow, styles.tableRowMargin10]}>
        <Text key={`sdate-${index}`} style={[styles.feesCoulumn]}>
          <Text style={styles.paragraph}>{fee.title}</Text>
        </Text>
        <Text key={`edate-${index}`} style={[styles.feesSecondCoulumn]}>
          <Text style={styles.paragraphHeading}>{fee.value}</Text>
        </Text>
      </View>
    );
  });
  const feesAndTotalSeparator = <View style={[styles.tableRow, styles.divider]}></View>;

  const feesTotalRow =
    feesTotal != null ? (
      <View style={[styles.tableRow, styles.tableRowMargin10]}>
        <Text style={[styles.feesCoulumn]}>
          <Text style={styles.paragraphHeading}>{feesTotal.title}</Text>
        </Text>
        <Text style={[styles.feesSecondCoulumn]}>
          <Text style={styles.paragraphHeading}>{feesTotal.value}</Text>
        </Text>
      </View>
    ) : null;
  return (
    <View>
      <View style={styles.tableRow}>
        <Text style={[styles.feesCoulumn]}>
          <Text style={styles.paragraphHeading}>Estimated cost of attendance</Text>
        </Text>
      </View>
      {feesAndPricingRow}
      {feesAndTotalSeparator}
      {feesTotalRow}
    </View>
  );
}
